module.exports = __webpack_public_path__ + "img/17-22.a1c54cf6.jpg";